export default __webpack_public_path__ + "static/media/15.5ab50ef7.jpg";